import * as yup from 'yup';

export const VIRTUAL_VISIT_REGEX =
  /^($|https?:\/\/(www\.)?my\.matterport\.com\/show\/|https?:\/\/(www\.)?nodalview\.com\/|https?:\/\/viewer\.realisti\.co\/|https?:\/\/tour\.giraffe360\.com\/|https?:\/\/(www\.)?kuula\.co\/share\/)/;

export const VirtualVisitSchema = yup.object({
  link: yup.string().matches(VIRTUAL_VISIT_REGEX, 'error')
});
